<template xmlns="http://www.w3.org/1999/html">
  <b-modal :size="isCadastreTour ? 'lg' : 'xl'" v-model="show" centered :title="'Tour anlegen'"
  >
    <b-row class="mt-2">
      <b-col md="2" class="my-auto">
        <span>Tourname</span>
      </b-col>
      <b-col>
        <b-form-input class="form-control text-black"
                      v-model="title"
                      :style="title === '' ? 'border-color: red;' : ''"

        ></b-form-input>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col md="2" class="my-auto">
        <span>Beschreibung</span>
      </b-col>
      <b-col>
        <b-form-textarea class="text-black"
                         style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                         rows="4"
                         no-resize
                         wrap="hard"
                         v-model="description"

        ></b-form-textarea>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col md="2" class="my-auto">
        <span>Leistungsgruppe</span>
      </b-col>
      <b-col>
        <b-input-group @click="onChangeLegr">
          <template #append>
            <edit-icon @click="onChangeLegr" title="" v-tooltip="'Anpassen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72"></edit-icon>
          </template>
          <b-form-input class="form-control text-black"
                        :style="legr.name === '' ? 'border-color: red; cursor: pointer;' : 'cursor: pointer;'"
                        v-model="legr.name"
                        disabled
          ></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" v-if="!isCadastreTour">
      <b-col md="2" class="my-auto">
        <span>Auftrag: An- und Abfahrt</span>
      </b-col>
      <b-col>
        <b-input-group @click="onChangeAufisn">
          <template #append>
            <edit-icon @click="onChangeAufisn" title="" v-tooltip="'Anpassen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72"></edit-icon>
          </template>
          <b-form-input class="form-control text-black"
                        v-model="startEndAuftrag.gi_match"
                        disabled
          ></b-form-input>
        </b-input-group>
        <b-form-text>Wird für die Anfahrt zum ersten und Abfahrt vom letzten Objekt verwendet. (Optional)</b-form-text>
      </b-col>
    </b-row >
    <b-row class="mt-2" v-if="!isCadastreTour">
      <b-col class="my-auto">
        <span style="text-decoration: underline"><b>Zuweisung</b></span>
      </b-col>
      <b-col>
      </b-col>
    </b-row>
    <b-row class="mt-2" v-if="!isCadastreTour">
      <b-col>
        <b-row>
          <b-col md="4" class="my-auto">
            <span>Zieldatum</span>
          </b-col>
          <b-col>
            <datetime
                style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"

                v-model="ziel"
                input-class="form-control"
                :input-style="ziel === null || ziel === '' ? 'border-color: red;' : 'color: black;'"
                input-id="date"
                :aria-placeholder="formateDate"
                :phrases="datetimeConfig.phrases"
                :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                :min-datetime="datetimeConfig.minTime"></datetime>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row class="mt-2">
          <b-col md="4" class="my-auto">
            <span>Fertigstellungsart</span>
          </b-col>
          <b-col>
            <b-form-select :options="close_automatic_select" id="close_automatic" :plain="true"
                           v-model="close_automatic"
                           class="mb-2 text-black"></b-form-select>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-2" v-if="!isCadastreTour">
      <b-col class="my-auto">
        <span>Verantwortlich / Abrechnend</span>
      </b-col>
      <b-col>
        <b-row>
          <b-col md="8" class="my-auto">
            <span>Ausführend: Mitarbeiter / Gruppen</span>
          </b-col>

          <b-col md="4">
            <b-row style="flex-direction: row-reverse; margin-right: 8px">
              <minus-icon title="" v-tooltip="'Entfernen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72" @click="onDeletePlanning"></minus-icon>
              <plus-icon title="" v-tooltip="'Hinzufügen'" class="icon-1_5x" fillColor="#2463ea" style="cursor: pointer; color: #2463ea; margin-left: 4px;margin-bottom: 2px;" :size="72" @click="$refs.select_plannings.showDialog(users)"></plus-icon>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-2" v-if="!isCadastreTour">
      <b-col md="2"></b-col>
      <b-col md="4">
        <v-jstree ref="js_tree" :allow-transition="false"
                  :style="selectedKostMigr === null ? 'flex: 1 0; border: 1px solid red; border-radius: 0.25rem;' : 'flex: 1 0; border: 1px solid #c0c0c0; border-radius: 0.25rem;'"
                  class="my-tree" :data="kostMigrs"
                  @item-click="onItemClicked"
                  show-checkbox></v-jstree>
      </b-col>
      <b-col md="6">
        <b-table striped hover selectable :items="selectedPlannings" :fields="planningFields"
                 select-mode="single"
                 selectedVariant="primary"
                 ref="group_table"
                 @row-selected="onRowSelected"
        >
        </b-table>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md"  variant="success" @click="onCreate" :disabled="!canContinue">
        Anlegen
      </b-button>
    </template>
    <select-planning-dialog ref="select_plannings" @planning-selected="onNewPlanning"></select-planning-dialog>
    <select-aufisn-dialog ref="select_aufisn" @aufisn-selected="onAufisnChanged"></select-aufisn-dialog>
    <select-legr-dialog ref="select_legr" @legr-selected="onLegrChanged"></select-legr-dialog>

  </b-modal>

</template>

<script>
import {DateTime as LuxonDateTime} from "luxon";
import {Server_URL} from "@/shared/utils";
import EditIcon from 'vue-material-design-icons/PencilCircle.vue';
import PencilPlusIcon from 'vue-material-design-icons/PencilPlus.vue';
import PlusIcon from 'vue-material-design-icons/PlusCircle.vue';
import MinusIcon from 'vue-material-design-icons/MinusCircle.vue';
import VJstree from 'vue-jstree'
import {v4} from "uuid";
import {parseTimestamp} from "@/shared/dates";
import {decryptAES, encryptAES} from "@/shared/crypto";
import AGeberDialog from "./AGeberDialog.vue"
import SelectPlanningDialog from "@/views/aufgaben_verwaltung/SelectPlanningDialog.vue";
import SelectAufisnDialog from "@/views/aufgaben_verwaltung/SelectAufisnDialog.vue";
import SelectLegrDialog from "@/views/aufgaben_verwaltung/SelectLegrDialog.vue";




export default {
  name: "CreateTourDialog",
  components: {
    SelectLegrDialog,
    SelectAufisnDialog,
    SelectPlanningDialog,
    EditIcon,
    PencilPlusIcon,
    PlusIcon,
    MinusIcon,
    VJstree,
    AGeberDialog
  },
  props:{
    bauhofStructure: {
      type: Array,
      default: () => []
    },
    isCadastreTour: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    redBorder() {
      if (this.isValidAuftrag) {
        return 'cursor: pointer;';
      } else {
        return "border-color: red; cursor: pointer;"
      }
    },
    canContinue() {
      return this.isCadastreTour ? this.title !== '' && this.legr.name !== '' : this.selectedKostMigr !== null && this.ziel !== null && this.ziel !== '' && this.title !== '' && this.legr.name !== '';
    }
  },
  data: () => {
    return {
      show: false,
      title: "",
      description: "",
      ziel: null,
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
      close_automatic: false,
      close_automatic_select: [{text: "Manuelle Fertigstellung", value: false}, {text: "Automatische Fertigstellung", value: true}],
      kostMigrs : [],
      selectedKostMigr: null,
      users: [],
      selectedPlannings: [],
      currentPlanning: null,
      planningFields: [{key: "name", label: 'Name'}],
      startEndAuftrag: {
        id: "",
        gi_match: "",
        gi_augr: "",
        gi_aufisn: "",
      },
      legr: {
        name: '',
      }
    }
  },
  watch: {
    bauhofStructure(n, o) {
      if (!n || !n.length) {
        return;
      }
      this.kostMigrs = this.computeKostMigrs(JSON.parse(JSON.stringify(n)));
      this.users = JSON.parse(JSON.stringify(n));
      this.computeMitas(this.users);
    },
  },
  methods: {
    onLegrChanged({selected_legr}) {
      this.legr = selected_legr
    },
    onChangeLegr() {
      this.$refs.select_legr.showDialog();
    },
    onAufisnChanged({selected_aufisn}) {
      this.startEndAuftrag = selected_aufisn;
    },
    onChangeAufisn() {
      this.$refs.select_aufisn.showDialog();
    },
    getReturnData() {
      let plannings = [];
      for (let i = 0; i < this.selectedPlannings.length; i++) {
        plannings.push(this.selectedPlannings[i].id);
      }
      let res = {
        titel: this.title,
        description: this.description,
        ziel: this.ziel,
        selectedKostMigr: this.selectedKostMigr,
        close_automatic: this.close_automatic,
        selectedPlannings: plannings,
        augr: this.startEndAuftrag.gi_augr,
        aufisn: this.startEndAuftrag.gi_aufisn,
        legr: this.legr.gischl
      }
      console.log(res)
      return res;
    },
    formateDueDate(value) {
      if (!value) {
        return ""
      } else {
        return parseTimestamp(new Date(Date.parse(value)), 'DD.MM.YYYY');
      }
    },
    onRowSelected(data) {
      if (data.length) {
        this.currentPlanning = data[0];
      } else {
        this.currentPlanning = null;
      }
    },
    onNewPlanning(selected) {
      for (let i = 0; i < selected.length; i++) {
        let cur = selected[i];
        cur._id = v4();
        this.selectedPlannings.push(cur);
      }
    },
    onDeletePlanning() {
      if (!this.currentPlanning) {
        return;
      }
      for (let i = 0; i < this.selectedPlannings.length; i++) {
        if (this.selectedPlannings[i]._id === this.currentPlanning._id) {
          this.selectedPlannings.splice(i, 1);
        }
      }
      this.currentPlanning = null;
    },
    onItemClicked(node, item, e) {
      this.selectedKostMigr = item;
    },
    async onCreate() {
      let data = this.getReturnData();
      this.$emit('plan-tour', data)
      this.show = false;
    },
    onCancel() {
      this.show = false;
    },
    async showDialog(addressData, isEinzel, title) {
      this.startEndAuftrag = {
        id: "",
        gi_match: "",
        gi_augr: "",
        gi_aufisn: "",
      };
      if (title) {
        this.title = title;
      } else {
        this.title = "";
      }
      this.show = true;
    },
    formateDate() {
      if (this.ziel === null) {
        return ""
      }
      let event = new Date(this.ziel.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },
    computeKostMigrs(data) {
      data.sort((a,b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
      let res = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type !== "user") {
          let cur = {...data[i]}
          cur.children = this.computeKostMigrs(cur.children)
          res.push(cur)
        }
      }
      return res;
    },
    computeMitas(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type === "user") {
          let cur = {...data[i]}
          let parsed = JSON.parse(sessionStorage.getItem(cur.id));
          if (parsed) {
            cur.text = parsed.full_name;
          }
          data[i] = cur;
        } else {
          this.computeMitas(data[i].children)
        }
      }
      data.sort((a,b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
    },
  }


}
</script>

<style>
.form-control:disabled, .form-control[disabled] {
  color: black !important;
}

.text-black {
  color: black;
}
</style>

<style scoped>

.my-tree {
  max-height: calc(30vh - 70px);
  overflow: auto;
}

</style>
